export const currentSeriesData:string[] = [
    "Indian Premier League",
    "Women's Premier League",
    "Pakistan Super League",
    "Sri Lanka tour of Bangladesh",
    "Indian Street Premier League"
]